module.exports = __webpack_public_path__ + "img/icon_send_message.ac9a7104.svg";